module.exports = __webpack_public_path__ + "static/assets/f80bea026887f31d886c59414682b5af.png";